/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_EventInputs */

const en_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go To Event`)
};

const fr_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller a l'evenement`)
};

const de_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Ereignis`)
};

const it_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'evento`)
};

const ru_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к мероприятию`)
};

const es_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al evento`)
};

const zh_cn2_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往活动`)
};

const ja_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントへ移動`)
};

const hi_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट पर जाएं`)
};

const pt_pt2_shortcut_keys_name_go_to_event = /** @type {(inputs: Shortcut_Keys_Name_Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o evento`)
};

/**
* | output |
* | --- |
* | "Go To Event" |
*
* @param {Shortcut_Keys_Name_Go_To_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_go_to_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_go_to_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_go_to_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_go_to_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_go_to_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_go_to_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_go_to_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_go_to_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_go_to_event(inputs)
	return en_shortcut_keys_name_go_to_event(inputs)
});